import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicButton, BasicInput, BaasicDropzone, DatePickerField, BaasicFieldDropdown } from "core/components";
import { Content } from "core/layouts";
import { map } from "lodash";
import moment from 'moment';

const TrackingCaseDocumentUploadModalTemplate = function({ trackingCaseDocumentUploadModalStore, t, componentProps }) {
    const {
        contentLoading,
        form,
        onFileDrop,
        acceptedFiles,
        isUploadInProgress,
        isDisabled,
        onClickUpload,
        removeAttachment,
        selectedFiles,
        documentTypeStores
    } = trackingCaseDocumentUploadModalStore;

    return (
    <form onSubmit={form.onSubmit}>
        <div className="modal__header">
            <h2 className="modal__header__title">Upload Tracking Case Documents</h2>
        </div>

        <div className="modal__body">
            <Content loading={contentLoading}>
                <div className="form__group">
                    <BaasicDropzone
                        onFilesDrop={onFileDrop}
                        acceptFiles={acceptedFiles}
                        multiple={true}
                        disabled={isUploadInProgress}
                    />
                </div>
                {map(form.$('formFields').value, form =>
                <div className="card--secondary" key={form.$('index').value}>
                    <div className="form__group k-upload-attachment">
                        {form.$('fileName').value}
                    </div>
                    <div className="row">
                        <div className="form__group col col-sml-12 col-med-6">
                            {!selectedFiles[form.$('index').value].uploaded ?
                                <BaasicFieldDropdown field={form.$('documentTypeId')} store={documentTypeStores[form.$('index').value]} />
                                : documentTypeStores[form.$('index').value].value.name
                            }
                        </div>
                        <div className="form__group col col-sml-12 col-med-6">
                            {!selectedFiles[form.$('index').value].uploaded ?
                                <BasicInput field={form.$('name')} />
                                : form.$('name').value
                            }
                        </div>
                        <div className="form__group col col-sml-12">
                            {!selectedFiles[form.$('index').value].uploaded ?
                                <BasicInput field={form.$('description')} />
                                : form.$('description').value
                            }
                        </div>
                        <div className="form__group col col-sml-12 col-med-6">
                            {!selectedFiles[form.$('index').value].uploaded ?
                                <DatePickerField field={form.$('validFrom')} />
                                : form.$('validFrom').value && moment(form.$('validFrom').value).format("YYYY-MM-DD") 
                            }
                        </div>
                        <div className="form__group col col-sml-12 col-med-6">
                            {!selectedFiles[form.$('index').value].uploaded ?
                                <DatePickerField field={form.$('validTo')} />
                                : form.$('validTo').value && moment(form.$('validTo').value).format("YYYY-MM-DD") 
                            }
                        </div>
                        {selectedFiles[form.$('index').value].uploading ? "Uploading..." :
                            selectedFiles[form.$('index').value].uploaded ? "Uploaded" :
                            <React.Fragment>
                                {selectedFiles[form.$('index').value].errorMsg != null && selectedFiles[form.$('index').value].errorMsg}
                                <BaasicButton
                                    className="card--secondary__close"
                                    label=""
                                    disabled={isUploadInProgress}
                                    icon="u-icon u-icon--tny u-icon--close"
                                    onClick={() => removeAttachment(form.$('index').value)}
                                />
                            </React.Fragment>
                        }
                    </div>
                </div>
                )}
            </Content>

            <div className="modal__footer">
                <BaasicButton
                    type='button'
                    className="btn btn--med btn--primary"
                    onClick={onClickUpload}
                    disabled={isDisabled}
                    label={"Upload & Save"}
                />
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => componentProps.modalParams.close()}
                />
            </div>
        </div>
    </form>
    );
};

TrackingCaseDocumentUploadModalTemplate.propTypes = {
    trackingCaseDocumentUploadModalStore: PropTypes.object.isRequired,
    componentProps: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(TrackingCaseDocumentUploadModalTemplate);
